import _version from "../../lib/version.js";
const version = _version;

/* Writing application name + cc-lib version, used in file metadata (e.g. ttm:desc, MCC Creation Program) */
export default (function getAppName() {
  return `Closed Caption Converter v${version}`;
});